var map = {
	"./commercial/0.jpg": 2299,
	"./commercial/1.jpg": 5639,
	"./commercial/2.jpg": 1633,
	"./commercial/3.jpg": 4744,
	"./commercial/4.jpg": 5481,
	"./food/0.jpg": 4789,
	"./food/1.jpg": 2311,
	"./food/2.jpg": 6457,
	"./food/3.jpg": 6470,
	"./food/4.jpg": 899,
	"./landscape/0.jpg": 9347,
	"./landscape/1.jpg": 7926,
	"./landscape/2.jpg": 3964,
	"./landscape/3.jpg": 7874,
	"./landscape/4.jpg": 8596,
	"./portraits/0.jpg": 2850,
	"./portraits/1.jpg": 6885,
	"./portraits/2.jpg": 3084,
	"./portraits/3.jpg": 9558
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 758;